import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface IUser {
  id: string | null
  firstName: string | null
  email: string | null
  lastName: string | null
  image: string | null
  jobTitle: string | null
}

const initialState: IUser = {
  id: null,
  firstName: null,
  lastName: null,
  email: null,
  image: null,
  jobTitle: null,
}

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<IUser>) {
      return { ...state, ...action.payload }
    },
    clearUser() {
      return { ...initialState }
    },
  },
})

export const { setUser, clearUser } = userSlice.actions

export const selectUser = (state: { user: IUser }) => state.user

export default userSlice.reducer
